// extracted by mini-css-extract-plugin
export var externalLink = "_7p-0";
export var internalLinkLabel = "_7p-1";